import { render } from "./EditInstance.vue?vue&type=template&id=b6bc16d6&ts=true"
import script from "./EditInstance.vue?vue&type=script&lang=ts"
export * from "./EditInstance.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__